import { BooLogo } from "@/components/BooLogo";
import { Button } from "@/components/ui/button";
import { signOut } from "@/lib/auth-client";
import { useSearch } from "@tanstack/react-router";
import { ShieldX } from "lucide-react";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export function BannedPage() {
  useDocumentTitle("Account suspended");
  const { reason: banReason, expires: banExpires } = useSearch({ strict: false }) as {
    reason?: string;
    expires?: string;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="mx-auto flex w-full max-w-sm flex-col items-center gap-6 px-4 text-center">
        <BooLogo className="size-16 rounded-2xl" />
        <div className="flex items-center gap-2 text-destructive">
          <ShieldX className="size-5" />
          <h1 className="text-xl font-semibold">Account Suspended</h1>
        </div>
        <p className="text-sm text-muted-foreground">
          {banReason || "Your account has been suspended. Please contact support for more information."}
        </p>
        {banExpires && (
          <p className="text-xs text-muted-foreground">
            Suspended until {new Date(banExpires).toLocaleDateString()}
          </p>
        )}
        <Button
          variant="outline"
          onClick={() => signOut({ fetchOptions: { onSuccess: () => window.location.assign("/login") } })}
        >
          Sign out
        </Button>
      </div>
    </div>
  );
}
